const GoogleRecaptcha = {
    REACT_APP_SITE_KEY:'6LeCEBQqAAAAAKzSeaFByfm68yzGoci5QAr6-xBu',
    SITE_SECRET:'6LeCEBQqAAAAAFZ_DKFXur1v2OhqCe9dj10rOouy'
}

export default GoogleRecaptcha